import { IS_SSR } from '../../constants/env';

export const ONE_TRUST_READY_EVENT = 'OneTrustReady';

/**
 * Calls `callback` now if OneTrust has already called `OptanonWrapper`, and on every `OneTrustReady`
 * event. `OneTrustReady` is dispatched from `OptanonWrapper` (see `OneTrustHeadScriptV2`), which
 * OneTrust calls once its API is ready and again on every consent change.
 *
 * Inserts must not run before the first `OptanonWrapper` call, even if the API already exists:
 * OneTrust only starts skipping repeated `InsertScript`/`InsertHtml` calls for a category after
 * that call, so an earlier insert would be repeated.
 *
 * Once `OptanonWrapper` has run, OneTrust skips later `InsertScript`/`InsertHtml` calls for a
 * category it has already handled, and their `onReady` is not called. Loaders that mount again
 * in the same document (e.g. after client-side navigation) must reuse the already loaded SDK.
 */
export function onOneTrustReady(callback: () => void): () => void {
    if (IS_SSR) {
        return () => undefined;
    }

    if (window.isOneTrustReady) {
        callback();
    }

    window.addEventListener(ONE_TRUST_READY_EVENT, callback);

    return () => {
        window.removeEventListener(ONE_TRUST_READY_EVENT, callback);
    };
}
